import { Alert, Button, Chip, CircularProgress, Container } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useCallback, useEffect, useState } from "react";
import { ORG_NOTIFICATION_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import AppTableView from "../AppTableView";
import NotificationDialog from "./NotificationDialog";
import { useAlert } from "../alerts/AlertContext";

const statusColors = {
  immediate: "#007BFF",
  "in-progress": "#FD7E14",
  high: "#FFC107",
  medium: "#20C997",
  low: "#6C757D",
};

function Notifications() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showAlert = useAlert();

  const getNotifications = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await AxiosInstance.get(ORG_NOTIFICATION_URL);
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching statuses:", error);
      setError("Failed to load statuses. Please try again.");
      // showAlert("Failed to load statuses", "error");
    } finally {
      setLoading(false);
    }
  }, [showAlert]);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  const columns = [
    {
      field: "notificationType",
      flex: 1,
      headerName: "Type",
      renderCell: (params) => params.value.name,
    },
    {
      field: "urgency",
      flex: 2,
      headerName: "Priority",
      renderCell: (params) => (
        <Chip
          label={params.value.name}
          color="primary"
          sx={{
            backgroundColor: statusColors[params.value.name.toLowerCase()],
            color: "white",
          }}
          size="small"
        />
      ),
    },
    {
      field: "title",
      flex: 1,
      headerName: "Title",
      renderCell: (params) => params.value,
    },
    {
      field: "startDate",
      flex: 1,
      headerName: "Start Date",
       renderCell: (params) => new Date(params.row?.startDate).toISOString().split("T")[0]
      
    },
    {
      field: "endDate",
      flex: 1,
      headerName: "End Date",
       renderCell: (params) => new Date(params.row?.endDate).toISOString().split("T")[0]
      
    },
     
    {
      field: "active",
      flex: 1,
      headerName: "Active",
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          sx={{
            borderRadius: 1,
            fontWeight: 500,
            minWidth: 70,
          }}
        />
      ),
    },
    {
      field: "action",
      flex: 1,
      headerName: "Actions",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <NotificationDialog
            editNotificationId={params.row.id}
            notificationName="Edit"
            variant="link"
          />
        </Box>
      ),
    },
  ];

  //if error content
  if (error) {
    return (
      <Container>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={getNotifications}>
              Retry
            </Button>
          }
          sx={{ borderRadius: 2 }}
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {/* loading or content */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <AppTableView rows={data} cols={columns} initialPageSize={5} />
      )}
    </Box>
  );
}

export default Notifications;
